// extracted by mini-css-extract-plugin
export default {"watermark":"Watermark_watermark__FC09P"};